import React from "react";

type Props = {
	children: React.ReactNode;
};

export default function Card({ children }: Props) {
	return <div className="relative p-4 rounded-lg border border-zinc-200">{children}</div>;
}
